import React from 'react'
import AddProduct from './AddProduct';
import { Route, Routes } from 'react-router-dom';
import ProductList from './ProductList';
import AddCategory from './category/AddCategory';
import CategoryList from './category/CategoryList';


export default function ProductRoutes() {
    return (
        <Routes>
            <Route path="/" element={<ProductList />} />
            <Route path="/add" element={<AddProduct />} />
            <Route path="/update/:id" element={<AddProduct />} />
            <Route path="/categoryList" element={<CategoryList />} />
            <Route path="/actionCategory" element={<AddCategory />} />
            <Route path="/updateCategory/:id" element={<AddCategory />} />
        </Routes>
    )
}
